"use client";

import { loadAndMergeAudio } from "mediatools";
import type { MediaOperation } from "./types";

export const mergeAudioOperation: MediaOperation<Record<string, never>> = {
  id: "merge-audio",
  group: "audio",
  inputKinds: ["audio"],
  outputKind: "audio",
  multiple: true,
  defaultOptions: {},
  run: async (ctx) => {
    if (ctx.files.length < 2) throw new Error("Add at least two files to merge.");
    const pcm = await loadAndMergeAudio(ctx.files);
    return { pcm, baseName: "merged" };
  },
};
